import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

const ContactForm = () => {
  const [formData, setFormData] = useState({fullName: "", mobileNumber: "", email: "", subject: "", message: "",});
  const [status, setStatus] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    AOS.init({ duration: 1000, easing: "ease-in-out", once: true });}, []);
    const handleChange = (e) => {setFormData({ ...formData, [e.target.name]: e.target.value });};
    const handleSubmit = async (e) => {
    e.preventDefault(); setIsLoading(true);
    const accessKey = process.env.REACT_APP_ACCESS_KEY;
    const formDataToSend = new FormData();
    formDataToSend.append("access_key", accessKey);
    formDataToSend.append("name", formData.fullName);
    formDataToSend.append("phone", formData.mobileNumber);
    formDataToSend.append("email", formData.email);
    formDataToSend.append("subject", formData.subject);
    formDataToSend.append("message", formData.message);
    formDataToSend.append("from_name", "New Era Education");
    try {
        const response = await fetch("https://api.web3forms.com/submit", {method: "POST", body: formDataToSend,});
        const result = await response.json();
        if (result.success) {
        setStatus("Thank you for reaching out! We'll get back to you soon.");
        setFormData({fullName: "", mobileNumber: "", email: "", subject: "", message: "",});}
        else {setStatus("Something went wrong. Please try again.");}}
    catch (error) {console.error("Error:", error); setStatus("Something went wrong. Please try again later or reach out to us directly at info@neweraeducation-eg.com.");} 
    finally {setIsLoading(false);}};

return (
    <div className="w-full mx-auto py-4 md:p-0">
    {/* FORM AREA */}
    <form data-aos="fade-right" onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-4 text-blue font-tenor text-sm md:text-base ">
    
    {/* LEFT COLUMN */}
    <div data-aos="zoom-in" className="flex flex-col justify-between h-full space-y-4">
    <input type="text" name="fullName" placeholder="Full Name" value={formData.fullName} onChange={handleChange} required
    className="w-full p-3 border rounded-md focus:border-2 focus:ring-yellow focus:border-yellow focus:outline-none"/>
        
    <input type="tel" name="mobileNumber" placeholder="Mobile Number" value={formData.mobileNumber} onChange={handleChange} required
    className="w-full p-3 border rounded-md focus:border-2 focus:ring-yellow focus:border-yellow focus:outline-none"/>
        
    <input type="email" name="email" placeholder="Email Address" value={formData.email} onChange={handleChange} required
    className="w-full p-3 border rounded-md focus:border-2 focus:ring-yellow focus:border-yellow focus:outline-none"/></div>

    {/* RIGHT COLUMN */}
    <div data-aos="zoom-in" className="flex flex-col justify-between h-full space-y-4">
    <input type="text" name="subject" placeholder="Subject" value={formData.subject} onChange={handleChange} required
    className="w-full p-3 border rounded-md focus:border-2 focus:ring-yellow focus:border-yellow focus:outline-none"/>
        
    <textarea name="message" placeholder="How can we help you?" value={formData.message} onChange={handleChange} required rows = '4'
    className="w-full p-3 border rounded-md focus:border-2 focus:ring-yellow focus:border-yellow focus:outline-none"></textarea></div>

    {/* SUBMIT BUTTON */}
    <div className="col-span-1 md:col-span-2"><button disabled={isLoading} type="submit" className="md:w-auto w-full bg-yellow hover:bg-blue hover:text-white text-blue py-2 px-8 rounded-md font-semibold transition duration-20 uppercase">Submit</button></div>
    </form>
        
    {/* SUBMIT STATUS  */}
    {status && <p className="font-tenor text-sm md:text-base mt-4 text-center text-blue">{status}</p>}
    </div>);};

    export default ContactForm;